"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiOutlinedInputOverrides = function (_a) {
    var palette = _a.palette, transitions = _a.transitions;
    return ({
        root: {
            "&:hover $notchedOutline": {
                borderColor: undefined,
            },
            "&$focused $notchedOutline": {
                borderWidth: undefined,
                borderColor: palette.text.primary,
            },
            "&$disabled $notchedOutline": {
                borderColor: undefined,
            },
        },
        input: {
            padding: undefined,
            "&:-webkit-autofill": {
                // Overriding MUI's hardcoded color
                // https://github.com/mui-org/material-ui/blob/3bc1e2d6148378b5dae57452df3c82ab17854f1d/packages/material-ui/src/OutlinedInput/OutlinedInput.js#L76
                WebkitBoxShadow: palette.type === "dark"
                    ? "0 0 0 100px " + palette.background.default + " inset"
                    : null,
            },
        },
        notchedOutline: {
            top: 0,
            padding: 0,
            borderColor: palette.dividerStrong,
            transition: transitions.create("border-color", {
                duration: transitions.duration.short,
            }),
            // Remove border "notch"
            "& legend": { display: "none" },
        },
        multiline: {
            padding: undefined,
        },
        inputMultiline: {
            padding: undefined,
        },
        adornedStart: {
            paddingLeft: undefined,
        },
        inputAdornedStart: {
            paddingLeft: undefined,
        },
        adornedEnd: {
            paddingRight: undefined,
        },
        inputAdornedEnd: {
            paddingRight: undefined,
        },
    });
};
//# sourceMappingURL=MuiOutlinedInput.js.map